const REGISTRATION_IPHONE_MAX_WIDTH_PX = 767;
const REGISTRATION_IPAD_MINI_MIN_WIDTH_PX = 768;
const REGISTRATION_IPAD_MINI_MAX_WIDTH_PX = 1099;
const REGISTRATION_M_MIN_WIDTH_PX = 1100;
const REGISTRATION_M_MAX_WIDTH_PX = 1399;
const REGISTRATION_M_MAX_HEIGHT_PX = 900;
const REGISTRATION_L_MIN_WIDTH_PX = 1400;
const REGISTRATION_L_MAX_WIDTH_PX = 1679;

const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_XL_PX = 1728;
const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_L_PX = 1440;
const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_M_PX = 1192;
const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPAD_PX = 744;
const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPHONE_PX = 393;

const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL_PX = 680;
const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_L_PX = 660;
const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_M_PX = 536;
const REGISTRATION_FORM_BOX_WIDTH_IPAD_PX = 536;
const REGISTRATION_FORM_BOX_WIDTH_IPHONE_PX = 357;
const REGISTRATION_TWO_COLUMN_GAP_XL_L_PX = 27;
const REGISTRATION_TWO_COLUMN_GAP_M_PX = 21;

const REGISTRATION_SINGLE_COLUMN_MAX_WIDTH_PX = 1166;
const REGISTRATION_TWO_COLUMN_WIDTH_PX =
  REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL_PX;
const REGISTRATION_FORM_CONTENT_MAX_WIDTH_PX = 393;
const REGISTRATION_FORM_CONTENT_MOBILE_MAX_WIDTH_PX = 305;
export const REGISTRATION_TESTIMONIAL_CARD_WIDTH_PX = 470;
export const REGISTRATION_TESTIMONIAL_CARD_GAP_PX = 24;
const REGISTRATION_TESTIMONIAL_VIEWPORT_MAX_WIDTH_PX = 653;
const REGISTRATION_DESKTOP_MIN_WIDTH_PX = REGISTRATION_M_MIN_WIDTH_PX;

export const REGISTRATION_SINGLE_COLUMN_MAX_WIDTH = `${REGISTRATION_SINGLE_COLUMN_MAX_WIDTH_PX}px`;
export const REGISTRATION_TWO_COLUMN_WIDTH = `${REGISTRATION_TWO_COLUMN_WIDTH_PX}px`;
export const REGISTRATION_FORM_CONTENT_MAX_WIDTH = `${REGISTRATION_FORM_CONTENT_MAX_WIDTH_PX}px`;
export const REGISTRATION_FORM_CONTENT_MOBILE_MAX_WIDTH = `${REGISTRATION_FORM_CONTENT_MOBILE_MAX_WIDTH_PX}px`;
export const REGISTRATION_TWO_COLUMN_GAP_XL_L = `${REGISTRATION_TWO_COLUMN_GAP_XL_L_PX}px`;
export const REGISTRATION_TWO_COLUMN_GAP_M = `${REGISTRATION_TWO_COLUMN_GAP_M_PX}px`;
export const REGISTRATION_IPHONE_MEDIA_QUERY = `screen and (max-width: ${REGISTRATION_IPHONE_MAX_WIDTH_PX}px)`;
export const REGISTRATION_IPAD_MINI_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_IPAD_MINI_MIN_WIDTH_PX}px) and (max-width: ${REGISTRATION_IPAD_MINI_MAX_WIDTH_PX}px)`;
export const REGISTRATION_M_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_M_MIN_WIDTH_PX}px) and (max-width: ${REGISTRATION_M_MAX_WIDTH_PX}px), screen and (min-width: ${REGISTRATION_M_MIN_WIDTH_PX}px) and (max-height: ${REGISTRATION_M_MAX_HEIGHT_PX}px)`;
export const REGISTRATION_L_MEDIA_QUERY = `screen and (min-width: ${REGISTRATION_L_MIN_WIDTH_PX}px) and (max-width: ${REGISTRATION_L_MAX_WIDTH_PX}px)`;
export const REGISTRATION_DESKTOP_MEDIA_QUERY = `(min-width: ${REGISTRATION_DESKTOP_MIN_WIDTH_PX}px)`;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_XL = `${REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_XL_PX}px`;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_L = `${REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_L_PX}px`;
export const REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_M = `${REGISTRATION_TWO_COLUMN_LAYOUT_MAX_WIDTH_M_PX}px`;
export const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPAD = `${REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPAD_PX}px`;
export const REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPHONE = `${REGISTRATION_SINGLE_COLUMN_LAYOUT_MAX_WIDTH_IPHONE_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL = `${REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_XL_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_L = `${REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_L_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_M = `${REGISTRATION_FORM_BOX_WIDTH_TWO_COLUMN_M_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_IPAD = `${REGISTRATION_FORM_BOX_WIDTH_IPAD_PX}px`;
export const REGISTRATION_FORM_BOX_WIDTH_IPHONE = `${REGISTRATION_FORM_BOX_WIDTH_IPHONE_PX}px`;
export const REGISTRATION_TESTIMONIAL_CARD_WIDTH = `${REGISTRATION_TESTIMONIAL_CARD_WIDTH_PX}px`;
export const REGISTRATION_TESTIMONIAL_VIEWPORT_MAX_WIDTH = `${REGISTRATION_TESTIMONIAL_VIEWPORT_MAX_WIDTH_PX}px`;
